import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client';

export const useDocumentUrl = (blobUri?: string) => {
  return useQuery({
    queryKey: ['document-url', blobUri],
    queryFn: async () => {
      if (!blobUri) {
        throw new Error('Blob URI is required');
      }
      const { data } = await apiClient.get<{ url: string }>('/documents/url', {
        params: { blob_uri: blobUri },
      });
      return data.url;
    },
    enabled: !!blobUri,
  });
};
